export const LOADING_TRUE = "loading_true";
export const LOADING_FALSE = "loading_false";
